export const siteConfig = {
  name: "SECoaching",
  owner: "Steffen",
  cvr: "44536390",
  email: "steffenbmw@gmail.com", // Keeping original email unless requested otherwise
  phone: "41174266",
  phoneFormatted: "+45 41 17 42 66",
  address: "Danmark",
  images: {
    logo: "https://assets.auxodev.dk/assets/06e215ef-94f8-4c3c-bc53-7852c768946e/ecf620ce-8b18-46c2-ab06-536dbc5bf284.png",
    portrait: "https://assets.auxodev.dk/assets/06e215ef-94f8-4c3c-bc53-7852c768946e/96762c9b-8612-4184-8af6-e4b1229feaf4.jpeg",
    hero: "https://assets.auxodev.dk/assets/06e215ef-94f8-4c3c-bc53-7852c768946e/d138cc09-7f90-4b04-aaa9-ca1750da8b92.jpeg",
    mindset: "https://assets.auxodev.dk/assets/06e215ef-94f8-4c3c-bc53-7852c768946e/4480b9f8-6994-43dd-9583-dd3bd7380912.jpeg"
  }
};

export const homeContent = {
  hero: {
    title: "Skab et stærkere mindset og tag næste skridt mod dine mål",
    text1: "Hos SECoaching hjælper jeg dig med at arbejde målrettet med dit mindset, så du kan skabe mere klarhed, handlekraft og balance i hverdagen.",
    text2: "Som uddannet mindsetcoach tilbyder jeg personlige forløb, hvor vi arbejder med dine mål, vaner, tanker og de mønstre, der enten støtter eller begrænser dig.",
    cta: "Book en samtale"
  },
  features: [
    {
      title: "Klarhed & Fokus",
      description: "Få defineret dine sande mål og skab en konkret handlingsplan for at nå dem."
    },
    {
      title: "Bryd Mønstre",
      description: "Identificer og arbejd med de begrænsende tanker og vaner, der holder dig tilbage."
    },
    {
      title: "Mental Balance",
      description: "Opbyg overskud og robusthed til at håndtere hverdagens udfordringer med ro."
    }
  ],
  whyChooseUs: {
    title: "Hvorfor vælge SECoaching?",
    points: [
      {
        title: "Personlig tilgang",
        text: "Ingen standardløsninger. Forløbet tilpasses 100% dine individuelle behov, udfordringer og mål."
      },
      {
        title: "Fremtidssikret helhed",
        text: "Med kommende udvidelser inden for kostvejledning og personlig træning tænkes krop og sind sammen."
      },
      {
        title: "Konkrete resultater",
        text: "Vi fokuserer på at omsætte dine mål til målbare handlinger, der skaber varig forandring."
      }
    ]
  }
};

export const programsContent = {
  intro: "Her kan du få et overblik over de forløb, jeg tilbyder. I første omgang tilbyder jeg mindsetcoaching, og på sigt vil der også komme forløb med fokus på kostvejledning og personlig træning.",
  programs: [
    {
      id: "mindsetforloeb",
      title: "Mindsetforløb",
      description: "Et personligt coachingforløb for dig, der ønsker at arbejde med dine tanker, mål og personlige udvikling.",
      price: "Kontakt for pris",
      cta: "Læs mere om mindsetforløbet",
      link: "/mindsetforloeb",
      active: true,
      tag: "Populær"
    },
    {
      id: "kostvejledning",
      title: "Kostvejledning",
      description: "Skræddersyede kostplaner og vejledning til et sundere liv i balance. Fokus på holdbare vaner uden strenge restriktioner.",
      price: "Kommer snart",
      cta: "Hold mig opdateret",
      link: "/kontakt",
      active: false,
      tag: "Under udvikling"
    },
    {
      id: "personlig-traening",
      title: "Personlig træning",
      description: "Individuelt tilpasset fysisk træning, der styrker din krop og understøtter dit mentale overskud.",
      price: "Kommer snart",
      cta: "Hold mig opdateret",
      link: "/kontakt",
      active: false,
      tag: "Under udvikling"
    }
  ]
};

export const mindsetDetailContent = {
  title: "Mindsetforløb",
  text1: "Et mindsetforløb er for dig, der ønsker at skabe forandring indefra. Sammen arbejder vi med dine mål, dine tankemønstre og de barrierer, der kan stå i vejen for din udvikling.",
  text2: "Forløbet kan hjælpe dig med at få mere klarhed, styrke din motivation og skabe konkrete handlinger, der bringer dig tættere på det liv eller de resultater, du ønsker.",
  relevantTitle: "Forløbet kan være relevant for dig, der ønsker at:",
  bullets: [
    "Få mere klarhed over dine mål",
    "Arbejde med begrænsende tanker",
    "Skabe bedre vaner",
    "Styrke din motivation",
    "Tage mere ansvar for din udvikling"
  ],
  price: "Kontakt for pris",
  cta: "Kontakt mig"
};

export const aboutContent = {
  title: "Om SECoaching",
  text1: "Mit navn er Steffen, og jeg er uddannet mindsetcoach. Jeg brænder for at hjælpe mennesker med at skabe personlig udvikling gennem stærkere mindset, more bevidsthed og konkrete handlinger.",
  text2: "Jeg er desuden i gang med at uddanne mig til kostvejleder og personlig træner, så jeg på sigt kan tilbyde en more helhedsorienteret tilgang til både mental og fysisk udvikling.",
  values: [
    {
      title: "Tillid & Tryghed",
      text: "Coaching er en personlig rejse. Hos mig er der fuld fortrolighed og et trygt rum til at dele alt."
    },
    {
      title: "Handling & Resultater",
      text: "Indsigt er godt, men handling skaber forandring. Vi fokuserer på konkrete, målbare skridt i din hverdag."
    },
    {
      title: "Helhedsorienteret fokus",
      text: "Mental styrke hænger sammen med din fysiske trivsel. Jeg arbejder mod at forene krop og sind."
    }
  ]
};

export const contactContent = {
  title: "Kontakt SECoaching",
  text: "Har du spørgsmål, eller ønsker du at høre mere om et mindsetforløb, er du velkommen til at kontakte mig.",
  info: {
    email: "steffenbmw@gmail.com",
    phone: "41174266",
    cvr: "44536390"
  }
};
